// QUICK VIEW SCRIPT
//declaring variables
let quickViewProduct;
let productTitle;
let productDescription;
let productFeaturedImage;
let productURL;
let productImages;

document.querySelectorAll(".quick-view").forEach((quickView, indexQuick) => {
  quickView.onclick = function () {
    quickViewProduct = quickView.dataset.handle;
    getJSON("/products/" + quickViewProduct + ".js")
      .then((productData) => {
        productTitle = productData.title;
        productDescription = productData.description;
        productFeaturedImage = productData.featured_image
          .replace(".jpg", "_600x.jpg")
          .replace(".png", "_600x.png");
        productURL = "/products/" + quickViewProduct;
        document.querySelector(".qv-product-title").innerText = productTitle;
        document.querySelector(".qv-product-description").innerHTML =
          productDescription;
        product_images = productData.media;
        product_images.forEach((imagee, index) => {
          document.querySelector(".splide__list").innerHTML =
            document.querySelector(".splide__list").innerHTML +
            `<div class="splide__slide">
							
								<img class=""
                                  src="${imagee.src}"
                                  width="${imagee.width}"
                                height="${imagee.height}"
                                  loading="lazy"
                                 alt="${imagee.alt}"
                                >
							
						</div>`;
        });

        var splide = new Splide(".splide");
        splide.mount();
        document.querySelector(".qv-close").addEventListener("click", () => {
          document.getElementById("quick-view").style.display = "none";
          document.querySelector(".splide__list").innerHTML = "";
        });
      })
      .catch((error) => {
        console.error(error);
      });
    setTimeout(() => {
      document.getElementById("quick-view").style.display = "flex";
    }, 500);
    var more_info_quickview = this.getAttribute("data-pluss");
    document.querySelector(".qv-link").onclick = () => {
      var elementss = document.querySelectorAll(
        `span[data-product-image="${more_info_quickview}"]`,
      );
      for (let k = 0; k < elementss.length; k++) {
        if (
          elementss[k].classList.contains("chosen") != true &&
          elementss[k].closest("[product-addon-item]").style.display !=
            "none"
        ) {
          document.querySelector(".qv-close").click();
          elementss[k].click();
        } else {
          document.querySelector(".qv-close").click();
        }
      }
    };
  };
});

const getJSON = async (url) => {
  const response = await fetch(url);
  if (!response.ok)
    // check if response worked (no 404 errors etc...)
    throw new Error(response.statusText);

  const data = await response.json(); // get JSON from the response
  return data; // returns a promise, which resolves to this data value
};

var splide = new Splide(".splide");
splide.mount();
